export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11253.65f4340d.jpg";